import { apiClient } from "../lib/api";

export const supplyPickupApi = {
  list: (params) => apiClient.get("/supply-pickup/assignments", { params }),
  get: (id) => apiClient.get(`/supply-pickup/assignments/${id}`),
  create: (payload) => apiClient.post("/supply-pickup/assignments", payload),
  recordActualTimes: (id, payload) => apiClient.patch(`/supply-pickup/assignments/${id}/actual-times`, payload),
  updateReimbursements: (id, payload) => apiClient.patch(`/supply-pickup/assignments/${id}/reimbursements`, payload),
  uploadReceipt: (id, formData) => apiClient.post(`/supply-pickup/assignments/${id}/receipt`, formData, { headers: { "Content-Type": "multipart/form-data" } }),
  driverConfirm: (id, payload) => apiClient.post(`/supply-pickup/assignments/${id}/driver-confirm`, payload),
  submit: (id) => apiClient.post(`/supply-pickup/assignments/${id}/submit`),
  approve: (id, payload) => apiClient.post(`/supply-pickup/assignments/${id}/approve`, payload),
  cancel: (id, payload) => apiClient.post(`/supply-pickup/assignments/${id}/cancel`, payload),
};
